import { render, staticRenderFns } from "./ImageAtom.vue?vue&type=template&id=b98b8032&"
import script from "./ImageAtom.vue?vue&type=script&lang=ts&"
export * from "./ImageAtom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports